import getField from '@form/formGenerator'

export const userSaveUrl = `${import.meta.env.VITE_API_URL}/api/users/register`

export const userFormObject = {
  id: null,
  email: null,
  fullName: null,
  cellPhone: null,
  roles: null,
  homePhone: null,
  company: null,
  companyLegalForm: null,
  companySiret: null,
  companyTvaNumber: null,
  address: null,
  zipCode: null,
  city: {},
  isActive: 0,
  jobTitle: null,
  mission: null
}

export const userFormFields = (userFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t, data, creationModalCaller) => {
  const fields = [
    {
      type: 'text',
      name: 'jobTitle',
      label: t('labels.title'),
      value: userFormObject.jobTitle,
      key: 'userFormObject-jobTitle',
      cssClass: 'column is-6',
      isRequired: true
    }, {
      type: 'text',
      name: 'fullName',
      label: t('labels.full_name'),
      value: userFormObject.fullName,
      key: 'userFormObject-fullName',
      cssClass: 'column is-6',
      isRequired: true
    },
    {
      type: 'email',
      name: 'email',
      label: t('labels.email'),
      value: userFormObject.email,
      key: 'userFormObject-email',
      cssClass: 'column is-6',
      isRequired: true
    },
    {
      type: 'text',
      name: 'cellPhone',
      label: t('labels.cell_phone'),
      value: userFormObject.cellPhone,
      key: 'userFormObject-cellPhone',
      cssClass: 'column is-6',
      isRequired: true
    },
    {
      type: 'text',
      name: 'homePhone',
      label: t('labels.home_phone'),
      value: userFormObject.homePhone,
      key: 'userFormObject-homePhone',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'address',
      label: t('labels.address'),
      value: userFormObject.address,
      key: 'userFormObject-address',
      cssClass: 'column is-6'
    },
    {
      type: 'number',
      name: 'zipCode',
      label: t('labels.zip_code'),
      value: userFormObject.zipCode,
      key: 'userFormObject-zipCode',
      cssClass: 'column is-6'
    },
    {
      type: 'select',
      name: 'city',
      label: t('labels.city'),
      value: typeof userFormObject.city === 'object' ? userFormObject.city.id : userFormObject.city,
      key: 'missionMairieFormObject-city',
      cssClass: 'mission-city column is-6',
      withIcon: false,
      help: t('help.city_help'),
      canCreate: true,
      creationModalCaller: () => creationModalCaller('city', 'cities'),
      options: data.cities,
      disabled: false,
      error: [],
      required: true
    },
    {
      type: 'radio',
      name: 'roles',
      label: t('labels.roles'),
      value: userFormObject.roles,
      key: 'userFormObject-roles',
      cssClass: 'column is-6',
      options: data.userRoles,
      isMultiple: true
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: userFormObject.isActive,
      cssClass: 'column is-6',
      key: 'userFormObject-isActive',
      id: 'userFormObject-isActive'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'userFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(userFormObject.id),
      key: 'userFormObject-id'
    },
    {
      type: 'hidden',
      name: 'mission',
      value: parseInt(userFormObject.mission),
      key: 'userFormObject-mission'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}